import React from "react";
import DynamicInputField from "../../sharedFiles/DynamicInputField/DynamicInputField";
import { useCart } from "./itemContext";
import {BsCart4} from "react-icons/bs";
import './summary.css';

const Summery = ({ isOtherCustomer, handleCheckBox, inputfieldLabel, setInputValue
    , inputValue,setRemarks, remarks, handleCheckoutButtonClick, isTableView
}) => {
    const { cart,  grandTotal} = useCart();
    // const cart = JSON.parse(sessionStorage.getItem('cart'));

    return (
        <div className="Check-div col-2 col-xl-2">
            <div className="input-fields-container">
                <label>
                    <input
                        type="checkbox"
                        checked={isOtherCustomer}
                        onChange={handleCheckBox}
                    />
                    &nbsp;
                    Other Customer
                </label>

                <DynamicInputField
                    inputfieldLabel={inputfieldLabel}
                    disabled={!isOtherCustomer}
                    setInputValue={setInputValue}
                    inputValue={inputValue}
                // reset={isOtherCustomer ? '' : null}
                />
            </div>
            {isTableView && 
            <div class="background-wrapper">
            {/* <div className="ItemList col-sm-10">
            <div className="ItemList-indicator">
                    <BsCart4 size={24}/>
                </div>
                <p>CHECKOUT ITEM LIST</p>
                <hr />
                {cart && cart.map((item, index) => {
                    return (
                        <div key={item.item_Code} className="item-separator">
                            {`${index + 1}. ${item.item_Code} - ${item.item_Name} * ${item.quantity}`}
                        </div>
                    );
                })}
            </div> */}
            </div>}
            {/* <div className="document-total">
                <div>
                    <p>Document Total</p>
                    <p>{grandTotal === null ? "0.00" : Number(grandTotal).toFixed(2)}</p>
                </div>
                <div className=" remarksDiv d-flex flex-column ">
                    <textarea
                        name=""
                        className="Remark-textArea"
                        id=""
                        value={remarks}
                        placeholder="Remarks"
                        onChange={(e) => {
                            setRemarks(e.target.value);
                        }}
                    ></textarea>
                </div>
            </div> */}

          <div className="document-total">
              <div className="total-section">
                  <p className="label">Document Total</p>
                  <p className="amount">{grandTotal === null ? "0.00" : Number(grandTotal).toFixed(2)}</p>
              </div>
              <div className="remarks-section">
                  <textarea
                      className="remark-textarea"
                      value={remarks}
                      placeholder="Add remarks..."
                      onChange={(e) => setRemarks(e.target.value)}
                      aria-label="Remarks"
                  ></textarea>
              </div>
          </div>

            <div className='check-btn'>
                <button onClick={handleCheckoutButtonClick}
                    className="CheckOut"
                // onClick={() => }
                >
                    Checkout
                </button>
            </div>
        </div>
    );
};

export default Summery;